import { SkeletonWithoutBreadcrumbs } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';

import { discoverRouteDefinition } from './route-definitions';

discoverRouteDefinition.component = Loadable({
  loader: () => import(/* webpackChunkName: "discover-view" */ './components/DiscoverView'),
  loading: () => null,
});

discoverRouteDefinition.header = Loadable({
  loader: () => import(/* webpackChunkName: "discover-header" */ './components/DiscoverHeader'),
  loading: SkeletonWithoutBreadcrumbs,
});

export const discoverRoute = discoverRouteDefinition;
